import PubSub from 'pubsub-js'

declare global {
  interface Window {
    dataLayer: any
  }
}

export class GoogleTagManager {
  static init = () => {
    // Page view tracking
    PubSub.subscribe('pageview', (_event, data) =>

    // TODO: This doesn't seem to work - may need to register on the server side with GTM
     window.dataLayer.push({
        'event': 'pageview',
        'page': {
          'path': new URL(data.url).pathname,
          'title': data.title
        }
      })
    )

    // Generic event tracking
    const monitoredEvents = ['user/signup', 'user/login', 'channel/create', 'form/create', 'account/invite', 'account/upgrade', 'account/downgrade']
    monitoredEvents.map((e) =>
      PubSub.subscribe(e, (event, _data) =>
        window.dataLayer.push({ 'event': event })
      )
    )
  }
}